import { c as _c } from "react/compiler-runtime";
import { FlexEnd, Separator } from "@opensea/ui-kit";
import { useTranslations } from "use-intl";
import { Button } from "../../../components/Button";
import { useConnect } from "../../../polychain/hooks";
import { PaymentMethodOptions, PaymentMethodOptionsCard, PaymentMethodOptionsWallet } from "../PaymentMethodOptions";
import { useCardCheckout } from "../use-card-checkout";
export function WalletPaymentStep(t0) {
  const $ = _c(15);
  const {
    cardDisabled,
    paymentMethod,
    timeline,
    setPaymentMethod,
    currencySelector,
    hidePaymentMethodOptions
  } = t0;
  const t = useTranslations("wallet.WalletPaymentStep");
  const {
    activeConnector
  } = useConnect();
  const cardCheckout = useCardCheckout();
  let t1;
  if ($[0] !== activeConnector || $[1] !== cardDisabled || $[2] !== hidePaymentMethodOptions || $[3] !== paymentMethod || $[4] !== setPaymentMethod) {
    t1 = !hidePaymentMethodOptions && <PaymentMethodOptions paymentMethod={paymentMethod} setPaymentMethod={setPaymentMethod}>{activeConnector?.id && <PaymentMethodOptionsWallet connectorId={activeConnector.id} selectedPaymentMethod={paymentMethod} />}{!cardDisabled && <PaymentMethodOptionsCard selected={paymentMethod === "card"} />}</PaymentMethodOptions>;
    $[0] = activeConnector;
    $[1] = cardDisabled;
    $[2] = hidePaymentMethodOptions;
    $[3] = paymentMethod;
    $[4] = setPaymentMethod;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== cardCheckout || $[7] !== currencySelector || $[8] !== paymentMethod || $[9] !== t || $[10] !== timeline) {
    t2 = paymentMethod === "card" ? <><FlexEnd><Button onClick={cardCheckout}>{t("payWithCard")}</Button></FlexEnd><Separator className="my-6" /></> : <>{currencySelector}<Separator className="my-6" />{timeline}</>;
    $[6] = cardCheckout;
    $[7] = currencySelector;
    $[8] = paymentMethod;
    $[9] = t;
    $[10] = timeline;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== t1 || $[13] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
}